import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  nombre: Yup.string().min(2).max(150).required()
})
